import html2canvas from 'html2canvas';
import {replaceMediaElementsForSnapshot} from './media';

/**
 * Used for turning DOM node to base64 image.
 *
 * Deep clones node to prevent errors if node is hidden and to not show changes made with
 * "u-domToImg" class that hides what shouldn't be shown in player but is visible in editor.
 */
export async function nodeToBase64(node: HTMLElement, filter?: (node: Node) => boolean, quality = 0.35): Promise<string> {
    const clonedNode: HTMLElement = node.cloneNode(true) as HTMLElement;
    clonedNode.style.width = `${node.offsetWidth}px`;
    clonedNode.style.height = `${node.offsetHeight}px`;
    clonedNode.classList.toggle('u-domToImg');
    clonedNode.style.position = 'absolute';
    clonedNode.style.left = '-9999px';

    document.body.appendChild(clonedNode);

    try {
        await replaceMediaElementsForSnapshot(node, clonedNode, quality);

        const canvas = await html2canvas(clonedNode, {
            logging: false,
            useCORS: true,
            scale: 1,
            imageTimeout: 0,
            ignoreElements: (element) => {
                return filter ? !filter(element) : false;
            },
        });

        return canvas.toDataURL('image/jpeg', quality);
    } finally {
        document.body.removeChild(clonedNode);
    }
}
